import { render, staticRenderFns } from "./DetalleCortesia.vue?vue&type=template&id=d739fc00&scoped=true&"
import script from "./DetalleCortesia.vue?vue&type=script&lang=js&"
export * from "./DetalleCortesia.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCortesia.vue?vue&type=style&index=0&id=d739fc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d739fc00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VIcon,VTextField})
